import { resolveAuthBaseUrl } from '@/helpers/apiContextDomain';
import { loadUserProfile } from '@/helpers/loadUserProfile';
import type { Session } from '@/helpers/signinUtils';
import { getStoredValue, setStoredValue } from '@/helpers/storage';

export const fetchUserProfile = async (baseUrl: string, token: string) => loadUserProfile(baseUrl, token);

export const persistAuthorizationWithProfile = async <T extends Session>(baseUrl: string, session: T): Promise<T> => {
  if (!session.accessToken) {
    setStoredValue('Authorization', session);
    return session;
  }

  const profile = await fetchUserProfile(baseUrl, session.accessToken);
  const existingAuth = getStoredValue<Record<string, unknown>>('Authorization') ?? {};
  const isSameUser = existingAuth.userId && existingAuth.userId === session.userId;
  const enrichedSession = {
    ...(isSameUser ? existingAuth : {}),
    ...session,
    firstName: profile?.firstName ?? session.firstName,
    lastName: profile?.lastName ?? session.lastName,
    preferredName: profile?.preferredName ?? session.preferredName,
  } as T;

  setStoredValue('Authorization', enrichedSession);

  return enrichedSession;
};

export const fetchVerifyEmailResponse = async (
  verificationId: string,
  token: string,
  baseAuthUrl: string,
): Promise<any> => {
  const authBaseUrl = resolveAuthBaseUrl({ authenticationBaseUrl: baseAuthUrl });

  try {
    const result = await fetch(`${authBaseUrl}account/verifyemail/${verificationId}`, {
      headers: {
        authorization: `bearer ${token}`,
      },
    });

    if (!result.ok) {
      throw new Error(result.statusText);
    }

    return result.json();
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`Verify Email call failed - ${error.message}`);
    }
    return null;
  }
};
